/** Client guard: decision handler exited without persisting (duplicate click, missing event, etc.). */
export function throwDecisionSkipped() {
  const err = new Error('Decision skipped');
  err.code = 'DECISION_SKIPPED';
  throw err;
}

export function isDecisionSkipped(error) {
  return error?.code === 'DECISION_SKIPPED';
}
